const downloadUrl = (url: string, headers: Record<string, string> = {}, fileName?: string) => {
  if (!window || !document) return
  const fileNameNormalized =
    fileName || headers['content-disposition']?.match(/filename="(.*)"/)?.groups?.[1] || document.title
  const mimeType = headers['content-type']?.split(';')[0] ?? ''

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileNameNormalized)
  link.setAttribute('type', mimeType)
  link.click()
  window.URL.revokeObjectURL(url)
}

const downloadBlob = (data: Blob, headers: Record<string, string> = {}, fileName?: string) => {
  if (!window || !document) return
  const url = window.URL.createObjectURL(data)
  downloadUrl(url, headers, fileName)
}

export const helpersDownload = {
  downloadUrl,
  downloadBlob,
}
